module.exports = "/images/home@2x.png?be8514215c128a097386b92d398ce912";